import CircularProgress from "@mui/material/CircularProgress";
import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TextField,
} from "@mui/material";
import { getPrecioArticulo } from "src/projects/gestion_documental/helpers/PrecioArticuloData";

export function ModalAgregarItem({ open, onClose, onConfirm, articulos, idCuenta }) {
  const [articulo, setArticulo] = useState(null);
  const [importe, setImporte] = useState("");
  const [cantidad, setCantidad] = useState(1);
  const [cargandoPrecio, setCargandoPrecio] = useState(false);

  useEffect(() => {
    if (open) {
      setArticulo(null);
      setImporte("");
      setCantidad(1);
    }
  }, [open]);

  useEffect(() => {
    if (!articulo) return;
    const fetchPrecio = async () => {
      setCargandoPrecio(true);
      const precio = idCuenta ? await getPrecioArticulo(articulo.alias, idCuenta) : 0;
      setImporte(precio);
      setCargandoPrecio(false);
    };
    fetchPrecio();
  }, [articulo, idCuenta]);

  const handleConfirm = () => {
    onConfirm({
      id_articulos: articulo.id,
      nombre: articulo.nombre,
      alias: articulo.alias,
      importe: parseFloat(importe) || 0,
      cantidad: parseInt(cantidad, 10) || 1,
    });
    onClose();
  };

  const puedeConfirmar = articulo && importe !== "" && parseFloat(importe) >= 0 && parseInt(cantidad, 10) > 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Agregar ítem</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: "16px !important" }}>
        <Autocomplete
          options={articulos}
          getOptionLabel={(o) => o.nombre ?? ""}
          isOptionEqualToValue={(o, v) => o.id === v.id}
          value={articulo}
          onChange={(_, v) => setArticulo(v)}
          renderInput={(params) => (
            <TextField {...params} label="Artículo *" size="small" />
          )}
        />
        <TextField
          label="Importe unitario *"
          size="small"
          type="number"
          value={importe}
          onChange={(e) => setImporte(e.target.value)}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
            endAdornment: cargandoPrecio ? <CircularProgress size={16} /> : null,
          }}
          inputProps={{ min: 0, step: "0.01" }}
        />
        <TextField
          label="Cantidad"
          size="small"
          type="number"
          value={cantidad}
          onChange={(e) => setCantidad(e.target.value)}
          inputProps={{ min: 1, step: 1 }}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button onClick={onClose} variant="outlined">
          Cancelar
        </Button>
        <Button onClick={handleConfirm} variant="contained" disabled={!puedeConfirmar}>
          Agregar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
